import {
  http
} from '../config';
import base from './base';

export const changePwd={
  changePwd(data){
    return http({
      url:`${base.users}/tea/changePassword`,
      method:'post',
      data,
      hideMessage:true,
    });
  },
  improveInfo(data){//完善资料提交
    return http({
      url:`${base.users}/tea/improveInformation`,
      method:'post',
      data,
      hideMessage:true,
    });
  },
  uploadFileToFastDfs(data){//发送资料
    return http({
      url: `${base.async}/fileServer/uploadFileToFastDfs`,
      method: 'post',
      data,
    });
  },
  uploadTeaResource(data){
    return http({
      url: `${base.async}/teacherFile/uploadTeaResource`,
      method: 'post',
      data,
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/changePwd.js